import { useMemo } from "react";
import { useProjectFunctions } from "@/hooks/useProjectPeople";
import { useProjectVehicleBookings } from "@/hooks/useVehicles";
import { buildVirtualDriverSeries } from "@/lib/vehicle-driver-function";

/**
 * The project's functions plus the virtual "Driver" function derived from
 * its vehicle bookings (see buildVirtualDriverSeries). Only for display in
 * the People tab; the driver is edited in the vehicle booking.
 */
export function useProjectFunctionsWithDrivers(projectId: string | undefined) {
  const functions = useProjectFunctions(projectId);
  const { data: bookings } = useProjectVehicleBookings(projectId);

  const data = useMemo(() => {
    const driver = projectId
      ? buildVirtualDriverSeries(projectId, bookings)
      : null;
    if (!driver) return functions.data;
    return [...functions.data, driver].sort((a, b) =>
      a.name.localeCompare(b.name),
    );
  }, [functions.data, bookings, projectId]);

  return { ...functions, data };
}
